//请自行添加语言资源
const toxinInspectVehicleArragement = {
  appointmentNo:'预约单号',
  vehicleNo:"车牌号",
  vehicleTypeName:"车型",
  grainOriginName:'粮源地',
  msg:{
    vehicleNo: '请输入车牌号'
  }
};
export default toxinInspectVehicleArragement



// WEBPACK FOOTER //
// ./src/page/toxin/toxinInspectVehicleArragement/lang/toxinInspectVehicleArragement.zh.js